export const LENDING_CLUB_LENDER_ID = 58;
